import React, { useEffect, useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { Icon } from 'react-native-elements';
import Colors from '../../../constants/Colorsv2';

type CarouselNavProps = { 
    size?:number, 
    inactive_color?:string, 
    active_color?:string, 
    items: any[],
    auto_change?:boolean,
    auto_change_seconds?:number,
    active_index:number,
    onIndexSelect: (index:number) => void 
}

const CarouselNav = ({ items, size, inactive_color, active_color, auto_change, auto_change_seconds, active_index, onIndexSelect }:CarouselNavProps) => {
    const [ autoChangeTimer, setAutoChangeTimer ] = useState<any>(undefined);
    let interval_index = 0
    
    useEffect(() => {
        if(!auto_change || items.length === 0){ return setAutoChangeTimer(clearInterval(autoChangeTimer)) }
        if(autoChangeTimer){ return }
        setAutoChangeTimer(setInterval(() => {
            if(!onIndexSelect){ return }
            interval_index += 1
            if(interval_index > items.length - 1){ interval_index = 0 }
            onIndexSelect(interval_index)
        }, auto_change_seconds ?? 10000))
    },[items.length])

    const inactiveColor = inactive_color ?? Colors.shades.shade600
    const activeColor = active_color ?? Colors.brand.electric

    const handleIndexSelect = (index:number) => {
        let obj = items[index]
        if(!obj){ return } //There are no more items here
        if(autoChangeTimer){ setAutoChangeTimer(clearInterval(autoChangeTimer)) }
        if(!onIndexSelect){ return } //Just in case the prop is forgotten
        onIndexSelect(index)
    }
    return (
        <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
            <TouchableOpacity style={{ height:30, width:30, borderRadius:100, backgroundColor:Colors.shades.shade600, justifyContent:'center', alignItems:'center' }} onPress={() => handleIndexSelect(active_index-1)}>
                <Icon name='chevron-left' type='feather' size={18} color={Colors.brand.midnight} />
            </TouchableOpacity>
            <View style={{ flexDirection:'row', alignItems:'center' }}>
            {items.map((i:any, index:number) => {
                const active = index === active_index ? true : false
                return (
                    <TouchableOpacity style={{ margin:5,height:size??8, width:size??8, backgroundColor:active?activeColor:inactiveColor, borderRadius:100 }} onPress={() => handleIndexSelect(index)}/>
                )
            })}
            </View>
            <TouchableOpacity style={{ height:30, width:30, borderRadius:100, backgroundColor:Colors.shades.shade600, justifyContent:'center', alignItems:'center' }} onPress={() => handleIndexSelect(active_index+1)}>
                <Icon name='chevron-right' type='feather' size={18} color={Colors.brand.midnight} />
            </TouchableOpacity>
        </View>
    )
}

export default CarouselNav